import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultProps = {
  fluid: false
};
const Container = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    bsPrefix,
    fluid,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    className,
    ...props
  } = _ref;
  const prefix = useBootstrapPrefix(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
  return /*#__PURE__*/_jsx(Component, {
    ref: ref,
    ...props,
    className: classNames(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
  });
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
export default Container;